export const reviews = {
  en: {
    // Senja testimonial grid.
    sectionHeadline: "What Our Customers Are Saying",
    readMore: "Read more",
    showLess: "Show less",
    loadMore: "Load more",
    // FullWidthReviews block "load more" button (full label, not the generic verb).
    loadMoreReviews: "Load More Reviews",
    // FullWidthReviews block headline fallback (when BE returns no headline).
    ravingFans: "Raving fans all over the world",
    // sr-only carousel label fallback when the headline is empty.
    customerReviews: "Customer reviews",
    // Suffix appended to the reviews carousel accessible name: "{headline} carousel".
    carousel: "carousel",
    // RemoteVideo social-proof line.
    over9000: "Over 9000 5-Star Reviews",
    // Trustpilot micro-combo chrome.
    trustpilot: {
      // Trust-score band labels (data.score.stars → label).
      excellent: "Excellent",
      great: "Great",
      average: "Average",
      poor: "Poor",
      bad: "Bad",
      // Visible combo: [<strong>{count}</strong>] + this suffix + [Trustpilot logo].
      // Suffix-only so the pre-formatted count keeps its own <strong> element.
      reviewsOnSuffix: "reviews on",
      // sr-only, non-interactive combo: "Rated {label}. {stars} out of 5. {count} reviews on Trustpilot"
      srRated: "Rated {label}. {stars} out of 5. {count} reviews on Trustpilot",
      srClickToView: "Click to view the company's Trustpilot profile",
    },
    // Accessible name for the review-slider landmark.
    sliderRegionLabel: "Trustpilot reviews",
    // Carousel navigation button labels (sr-only intent).
    previousReview: "Previous review",
    nextReview: "Next review",
    // Trustpilot SEO reviews section (server-rendered PDP block).
    // {count} = pre-formatted total review count.
    reviewsSectionHeading: "Reviews {count}",
    // Company reply header on a review: "Reply from {business}, {date}". The
    // date is rendered separately, so this is the "Reply from {business}," run.
    replyFrom: "Reply from {business},",
    // Verified-review badge + its explainer popup.
    verifiedCollectedBy: "Verified, collected by {business}",
    verifiedExplainer:
      "Product reviews are labeled verified when a company invites people to leave a review, using our supported invitation methods.",
    verifiedLearnMore: "Learn more",
    // Standalone verified-review badge label + its popup title, and the trailing
    // run after the "Learn more" link ("[Learn more] about review types").
    verifiedBadge: "Verified",
    verifiedReviewTitle: "Verified review",
    aboutReviewTypes: "about review types",
    // Slider footer, split around the pre-formatted <strong>{stars}</strong> and
    // the {count}-reviews link so both keep their own markup:
    //   "Rated " [<strong>{stars}</strong>] " / 5 based on " [{count} reviews] "."
    ratedPrefix: "Rated",
    ratedSuffix: "/ 5 based on",
    // Trailing sentence after the review-count link.
    showingFavorites: "Showing our favorite reviews.",
    // Standalone noun appended to the pre-formatted count ("{count} reviews").
    reviewsCountNoun: "reviews",
  },
  de: {
    sectionHeadline: "Das sagen unsere Kunden",
    readMore: "Mehr lesen",
    showLess: "Weniger anzeigen",
    loadMore: "Mehr laden",
    loadMoreReviews: "Mehr Bewertungen laden",
    ravingFans: "Begeisterte Fans auf der ganzen Welt",
    customerReviews: "Kundenbewertungen",
    carousel: "Karussell",
    over9000: "Über 9000 5-Sterne-Bewertungen",
    trustpilot: {
      excellent: "Hervorragend",
      great: "Großartig",
      average: "Durchschnittlich",
      poor: "Mangelhaft",
      bad: "Ungenügend",
      reviewsOnSuffix: "Bewertungen auf",
      srRated:
        "Bewertet mit {label}. {stars} von 5. {count} Bewertungen auf Trustpilot",
      srClickToView:
        "Klicken, um das Trustpilot-Profil des Unternehmens anzuzeigen",
    },
    sliderRegionLabel: "Trustpilot-Bewertungen",
    previousReview: "Vorherige Bewertung",
    nextReview: "Nächste Bewertung",
    reviewsSectionHeading: "Bewertungen {count}",
    replyFrom: "Antwort von {business},",
    verifiedCollectedBy: "Verifiziert, gesammelt von {business}",
    verifiedExplainer:
      "Produktbewertungen werden als verifiziert gekennzeichnet, wenn ein Unternehmen Personen über unsere unterstützten Einladungsmethoden zur Abgabe einer Bewertung einlädt.",
    verifiedLearnMore: "Mehr erfahren",
    verifiedBadge: "Verifiziert",
    verifiedReviewTitle: "Verifizierte Bewertung",
    aboutReviewTypes: "über Bewertungstypen",
    ratedPrefix: "Bewertet mit",
    ratedSuffix: "/ 5 auf Basis von",
    showingFavorites: "Wir zeigen eine Auswahl unserer Bewertungen.",
    reviewsCountNoun: "Bewertungen",
  },
} as const
